import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { OrgSelectorService } from 'src/app/core/services/org-selector.service';

import { PhoneUtils } from '../../../../utils/phone-utils';
import { OrgUser } from '../../models/organizations.model';
import {
	fetchOrgUsersClear,
	fetchOrgUsersStart,
} from '../../state/organizations.actions';
import { selectUsers } from '../../state/organizations.selector';

@Component({
	selector: 'app-users',
	styleUrls: ['./users.component.scss'],
	templateUrl: './users.component.html',
})
export class UsersComponent implements OnInit, OnDestroy {
	activeUsers: boolean = true;
	loading: boolean = true;
	navTab: string = 'active';
	phoneMask = (value: string): string => {
		return PhoneUtils.phoneMask(value);
	};

	users: OrgUser[] = [];

	usersTabs = [
		{ label: 'Ativos', path: 'active' },
		{ label: 'Inativos', path: 'inactive' },
	];
	private orgId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly store: Store,
		private readonly orgService: OrgSelectorService,
	) {}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchOrgUsersClear());
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id }) => {
			if (id) {
				this.orgId = id;
				this.navTab = this.orgService.tabNavigation || 'active';
				this.loading = true;
				this.store.dispatch(fetchOrgUsersStart({ id: id, status: 'active' }));
				this.store
					.select(selectUsers)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((users) => {
						if (users) {
							this.users = users;
							this.loading = false;
						}
					});
			}
		});
	}

	onEditUser(id: string): void {
		if (this.orgId) {
			const status = this.activeUsers ? 'ativo' : 'inativo';
			this.router.navigate([
				'organizacoes',
				this.orgId,
				'usuarios',
				status,
				id,
			]);
		}
	}

	onTabClick(cdt: string): void {
		if (!(cdt !== 'active' && cdt !== 'inactive')) {
			this.activeUsers = cdt === 'active';
			this.loading = true;
			this.store.dispatch(fetchOrgUsersStart({ id: this.orgId, status: cdt }));
		}
	}
}
